export default {"src":"/_next/static/media/playground.bcd3dc2e.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};